import { Fragment, useEffect, useState } from 'react';
import { Grid, TextField, useMediaQuery } from '@mui/material';
import * as ExcelJS from 'exceljs';
import { Button } from '@mui/material';
import { styled } from '@mui/material';
import Modal from './Modal';
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, Typography } from '@mui/material';
import { ReactComponent as ExcelIcon } from '../assets/icons/main/microsoft-excel-icon.svg';
import { ReactComponent as AlertIcon } from '../assets/icons/main/alertIcon.svg';
import { minLength, maxLength, stringPattern } from '../utils/form-validations';
import FileExport from './FileExport';
import { palette } from '../theme/palette';
// const stringPattern = '^[a-zA-Z0-9_][a-zA-Z0-9_ ]*[a-zA-Z0-9_]$';
import reduce from 'lodash/reduce';
import Styles from '../theme/commonCss/Styles';

const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;
/**
 * excelschema is required to match with the excel columns
 * excelschema should contain key value pair, we are checking type of value, string is supported for now
 */
const fileTypes = ['xlsx', 'csv'];
const FileImport = (props: any) => {
  const { excelSchema, style, data, uniqueParams, entityName, dataColumns } = props;
  const [extractedData, setExtractedData] = useState<any[]>([]);
  const [isModalOpen, setisModalOpen] = useState<boolean>(false);
  const [columns, setColumns] = useState<any[]>([]);
  const [loading, setLoading] = useState({ isLoading: false, message: '', success: false });
  const [excelTitlesData, setExcelTitlesData] = useState<any>({});
  useEffect(() => {
    if (extractedData.length > 0) {
      //const _schemaData: any = (Object.keys(excelSchema).length > 0) ? Object.keys(excelSchema) : [];
      setColumns(
        excelTitlesData.map((item: any, index: any) => {
          return {
            field: item.replace(' ', '_').toLowerCase(),
            headerName: (index > (dataColumns.length - 1)) ? item.toUpperCase() : (entityName) ? entityName.toUpperCase() + ' ' + item.split(' ')[1] : item.toUpperCase(),
            flex: 1,
            minWidth: item.length > 5 ? item.length * 12 : item.length * 20,
            renderCell: (params: any) => handleRenderCell(params),
          };
        })
      );
    }
  }, [extractedData]);

  const uploadFile = (e: any) => {
    setColumns([]);
    setExtractedData([]);
    let files = e.target.files;
    if (files.length) {
      let fileData = e.target.files[0];
      let extension = files[0].name.split('.').pop().toLowerCase(),
        isSuccess = fileTypes.indexOf(extension) > -1;

      if (isSuccess) {
        setLoading({ isLoading: true, message: 'Loading Data', success: false });
        setisModalOpen(true);
        const fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          if (e.target.result) {
            const dataBuffer = e.target.result;
            const workbook = new ExcelJS.Workbook();
            if (extension === 'csv') {
              parseCSVData(dataBuffer);
            } else {
              workbook.xlsx
                .load(dataBuffer)
                .then(() => {
                  let excelTitles: any = [];
                  let excelData: any = [];
                  let metaTags: any = [];
                  let _excelSchema = dataColumns;
                  if (workbook.worksheets[0]) {
                    workbook.worksheets[0].eachRow((row: any, rowNumber: any) => {
                      // rowNumber 0 is empty
                      if (rowNumber > 0) {
                        // get values from row
                        let rowValues: any = row.values;
                        // remove first element (extra without reason)
                        rowValues.shift();
                        // titles row
                        if (rowNumber === 1) excelTitles = rowValues;
                        // table data
                        else {
                          // create object with the titles and the row values (if any)
                          let rowObject: any = {};
                          for (let i = 0; i < excelTitles.length; i++) {
                            let title = _excelSchema[i] //.replace(' ', '_').toLowerCase();
                            let value = rowValues[i] ? rowValues[i] : '';
                            if (i > (_excelSchema.length - 1)) {
                              title = excelTitles[i].replace(' ', '_').toLowerCase();
                            }
                            if (typeof value === 'number') {
                              rowObject[title] = value.toString();
                            } else {
                              rowObject[title] = value;
                            }
                          }
                          rowObject['id'] = rowNumber - 1;
                          excelData.push(rowObject);
                        }
                      } else {
                        setLoading({
                          isLoading: false,
                          message: 'Excel file does not contain any row. Please check and try again.',
                          success: false,
                        });
                      }
                    });

                    setExcelTitlesData(excelTitles.map((item: any, index: any) => {
                      if (index > (_excelSchema.length - 1)) {
                        return item
                      } else {
                        return _excelSchema[index].toUpperCase().replace('_', ' ');
                      }
                    }));

                    const _resCheckHeader = checkHeader(excelTitles);
                    if (_resCheckHeader.success) {
                      if (excelData.length > 0) {
                        setExtractedData(
                          excelData.map((item: any, index: number) => {
                            let _hasError: boolean = validateString(item);
                            if (uniqueParams && data && data.length && uniqueParams.length) {
                              for (let keys of uniqueParams) {
                                if (item[keys]) {
                                  if (
                                    data.findIndex(
                                      (e: any) => e[keys].toLowerCase() === item[keys].toString().toLowerCase().trim()
                                    ) > -1
                                  ) {
                                    return { ...item, hasError: true };
                                  }
                                }
                              }
                            }
                            return { ...item, hasError: _hasError };
                          })
                        );
                        setTimeout(() => {
                          setLoading({ isLoading: false, message: '', success: true });
                        }, 1000);
                      } else {
                        setColumns([]);
                        setExtractedData([]);
                        setLoading({
                          isLoading: false,
                          message: 'It looks like you dont have data in excel file, please check and try again.',
                          success: false,
                        });
                      }
                    } else {
                      setLoading(_resCheckHeader);
                    }
                  } else {
                    setLoading({
                      isLoading: false,
                      message: 'Excel does not contain any sheets, please check and try again.',
                      success: false,
                    });
                  }
                })
                .catch((err: any) => {
                  setColumns([]);
                  setExtractedData([]);
                  setLoading({
                    isLoading: false,
                    message:
                      'Not able to read excel file, Please check file format, for reference download template and try again. [' +
                      err.message +
                      ']',
                    success: false,
                  });
                });
            }
          } else {
            setisModalOpen(true);
            setLoading({
              isLoading: false,
              message: 'Not able to read ' + fileData.name + ', Please check format and try again',
              success: false,
            });
          }
        };
        if (extension === 'csv') {
          fileReader.readAsText(fileData);
        } else {
          fileReader.readAsBinaryString(fileData);
        }
      } else {
        setisModalOpen(true);
        setLoading({
          isLoading: false,
          message: 'File ' + fileData.name + ' is not supported, Please upload excel/csv',
          success: false,
        });
      }
    } else {
      setisModalOpen(true);
      setLoading({ isLoading: false, message: 'Not able to find uploaded file, Please try again', success: false });
    }
  };

  const parseCSVData = (str: string, delim = ';') => {
    delim = str.slice(0, str.indexOf('\n')).indexOf(',') > -1 ? ',' : ';';
    if (delim === ',' || delim === ';') {
      const _headers = str
        .slice(0, str.indexOf('\n'))
        .split(delim)
        .filter((item) => item.trim().length > 0);
      setExcelTitlesData(_headers);
      const _resCheckHeader = checkHeader(_headers);
      if (_resCheckHeader.success) {
        const _rows = str
          .slice(str.indexOf('\n') + 1)
          .split('\n')
          .filter((item) => item.trim().length > 0);
        const _csvModifiedData = _rows.map((row: any, index: number) => {
          const values = row.split(delim);
          const eachObject = _headers.reduce((obj: any, header, i) => {
            obj[header.trim().replace(' ', '_').toLowerCase()] = values[i].trim();
            obj['id'] = index + 1;
            return obj;
          }, {});

          return eachObject;
        });
        if (_csvModifiedData && _csvModifiedData.length > 0) {
          setExtractedData(
            _csvModifiedData.map((item: any) => {
              let _hasError = validateString(item);
              if (data.length && uniqueParams.length) {
                for (let keys of uniqueParams) {
                  if (item[keys]) {
                    if (
                      data.findIndex((e: any) => e[keys].toLowerCase() === item[keys].toString().toLowerCase().trim()) >
                      -1
                    ) {
                      return { ...item, hasError: true };
                    }
                  }
                }
              }
              return { ...item, hasError: _hasError };
            })
          );
          setTimeout(() => {
            setLoading({ isLoading: false, message: '', success: true });
          }, 1000);
        } else {
          setColumns([]);
          setExtractedData([]);
          setLoading({
            isLoading: false,
            message: 'CSV file does not contain any data, please check and upload again.',
            success: false,
          });
        }
      } else {
        setLoading(_resCheckHeader);
      }
    } else {
      setLoading({
        isLoading: false,
        message: 'CSV file is not valid or not maching with the requied format, please check template for reference.',
        success: false,
      });
    }
  };

  const checkHeader = (header: any) => {
    const _header = header.map((item: any) => item.trim().replace(' ', '_').toLowerCase());
    if (_header.length) {
      if (_header.includes('id') || _header.includes('ID') || _header.includes('Id')) {
        return {
          isLoading: false,
          message: 'Colums are not allowed with id keyword, please change it with alternative name',
          success: false,
        };
      } else {
        const _schemaData: any =
          Object.keys(excelSchema).length > 0
            ? Object.keys(excelSchema).filter((item: any) => typeof excelSchema[item] == 'string')
            : [];

        if (_header.length >= _schemaData.length - 1) {
          const contains = _header.every((element: any, index: any) => {
            if (index < _schemaData.length) {
              return _schemaData.indexOf(element) !== -1;
            } else {
              return true;
            }
          });

          if (true) {
            return { isLoading: false, message: '', success: true };
          } else {
            return {
              isLoading: false,
              message: 'Headers are not matching with template, please check & try again',
              success: false,
            };
          }
        } else {
          return {
            isLoading: false,
            message: 'Colums are not as per template, please check & try again',
            success: false,
          };
        }
      }
    } else {
      return {
        isLoading: false,
        message: 'Headers are not present, please check template and try again',
        success: false,
      };
    }
  };

  const validateString = (item: any) => {
    const validateItemList: any = reduce(
      item,
      (acc: any, value: any, key: any) => {
        if (Object.keys(excelSchema).includes(key)) {
          acc[key] = value;
        }
        return {
          ...acc,
        };
      },
      {}
    );
    return Object.values(validateItemList).some((vals: any) => {
      return vals.length < minLength || vals.length > maxLength;
    });
  };

  const changeSchemaBuilderValue = (e: any, row: any) => {
    const { name, value } = e.target;
    // const newextractedData = JSON.parse(JSON.stringify(extractedData));
    // console.log(e.target.selectionStart,"selectionStart")
    // const savedPos = e.target.selectionStart;
    const updatedSchema = extractedData.map((schema: any) => {
      if (schema.id === row.id) {
        return {
          ...schema,
          [name]: value,
        };
      }
      return schema;
    });

    setExtractedData(
      updatedSchema.map((item: any, index: number) => {
        if (row.id === index + 1) {
          let _hasError = validateString(item);
          if (uniqueParams && data && data.length && uniqueParams.length) {
            for (let keys of uniqueParams) {
              if (item[keys]) {
                if (
                  data.findIndex((e: any) => e[keys].toLowerCase() === item[keys].toString().toLowerCase().trim()) > -1
                ) {
                  return { ...item, hasError: true };
                }
              }
            }
          }
          return { ...item, hasError: _hasError };
        } else {
          return { ...item };
        }
      })
    );
  };

  const handleRenderCell = (params: any) => {
    let regPattern = new RegExp(stringPattern);
    let error: boolean = false;
    let message: string = '';
    if (Object.keys(excelSchema).includes(params.field)) {
      if (typeof params.value === 'string' || typeof params.value === 'number') {
        if (params.value.trim().length === 0) {
          error = true;
          message = 'Field is blank';
        } else if (params.value.length < minLength) {
          error = true;
          message = 'Min length is ' + minLength;
        } else if (params.value.length > maxLength) {
          error = true;
          message = 'Mxn length is ' + maxLength;
        } else if (!regPattern.test(params.value)) {
          error = true;
          message = 'Should not contain special character';
        } else {
          if (uniqueParams && uniqueParams.length && data && data.length) {
            if (uniqueParams.includes(params.field)) {
              if (
                data.findIndex((e: any) => e[params.field].toLowerCase() === params.value.toLowerCase().trim()) > -1
              ) {
                error = true;
                message = 'Duplicate field';
              } else {
                error = false;
                message = '';
              }
            } else {
              error = false;
              message = '';
            }
          } else {
            error = false;
            message = '';
          }
        }
      } else {
        error = true;
        message = 'Should not contain special character';
      }
    }

    return (
      <TextField
        variant='outlined'
        size='small'
        name={params?.field}
        value={extractedData.find((schema: any) => schema.id === params.id)[params.field]}
        // defaultValue={params.value}
        onChange={(e: any) => changeSchemaBuilderValue(e, params?.row)}
        error={error}
        onKeyDown={(event: any) => {
          event.stopPropagation();
        }}
        helperText={error && message}
        sx={{
          '.MuiOutlinedInput-root': {
            fontSize: '1rem',
            marginTop: error ? '1rem' : '',
          },
          '.MuiFormHelperText-root': {
            color: 'rgba(255,0,0,0.5) !important',
            marginTop: '2px !important',
            marginLeft: '5px !important',
            fontSize: '0.8rem !important',
            lineHeight: '1 !important',
            marginBottom: '5px',
          },
        }}
      />
    );
  };

  const closeModal = () => {
    setisModalOpen(false);
    setColumns([]);
    setExtractedData([]);
    if(props.layout === 'popup'){
      props.closeBulkModal();
    }  
   
  };

  const handleSave = () => {
    const checkData = extractedData.map((item: any, index: number) => {
      let _hasError = validateString(item);
      if (uniqueParams && data && data.length && uniqueParams.length) {
        for (let keys of uniqueParams) {
          if (item[keys]) {
            if (data.findIndex((e: any) => e[keys].toLowerCase() === item[keys].toString().toLowerCase().trim()) > -1) {
              return { ...item, hasError: true };
            }
          }
        }
      }
      return { ...item, hasError: _hasError };
    });
    setExtractedData(checkData);

    if (checkData.filter((item) => item.hasError).length === 0) {
      const _schemaDataLength: any = Object.keys(excelSchema).length > 0 ? Object.keys(excelSchema) : [];
      const finalExtractedData: any = [];
      let newData: any = [];
      let rowObj: any = {};
      if (excelTitlesData.length >= _schemaDataLength.length) {
        for (let index = 0; index < extractedData.length; index++) {
          for (let cols of excelTitlesData) {
            if (_schemaDataLength.includes(cols.replace(' ', '_').toLowerCase())) {
              rowObj[cols.replace(' ', '_').toLowerCase()] = extractedData[index][cols.replace(' ', '_').toLowerCase()];
            } else {
              if (cols != 'id' && cols != 'hasError') {
                newData.push({ key: cols, value: extractedData[index][cols.replace(' ', '_').toLowerCase()] });
              }
            }
          }
          rowObj[_schemaDataLength[_schemaDataLength.length - 1]] = newData;
          finalExtractedData.push(rowObj);
          newData = [];
          rowObj = {};
        }
        props.action(finalExtractedData);
      } else {
        props.action(extractedData);
      }

      if(props.layout != 'popup'){
        closeModal() 
      }     

    }
  };

  const responsiveSize = useMediaQuery('(max-width:900px)');

  return (
    <>
      {props.layout === 'popup' ?
        <>
          <Fragment>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              sx={{
                display: 'flex',
                justifyContent: responsiveSize ? 'flex-start' : 'flex-end',
                p: responsiveSize ? '0 0 4px' : '10px 0 0',
                marginTop: '12px',
              }}
            >
              <Typography sx={Styles.inputLabel} className={true ? 'required-field' : ''}>
                Import Excel / CSV File
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={8} sx={{ marginTop: '12px', marginBottom: '12px' }}>
              <Button               
                sx={{
                  width: '100%',
                  display: 'flex',
                  padding: '0px 16px',
                  justifyContent: 'space-between',
                  borderColor: '#D9DFED',
                  textTransform: 'lowercase',
                  ':hover': {
                    backgroundColor: 'transparent !important',
                  },
                }}
                variant='outlined'
                // startIcon={<ExcelIcon {...(!props.hasAccess && { style: { opacity: 0.3, filter: 'grayscale(100%)' } })} />}
                component='label'
              // sx={style}
              // disabled={!props.hasAccess}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    fontStyle: 'italic',
                    color: '#7382A9B2',
                    flexDirection: 'row',
                    textTransform: 'capitalize',
                  }}
                >
                  Select File
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    textTransform: 'uppercase',
                    padding: '9px 0px 9px 16px',
                    borderLeft: '1px solid #d9dfed',
                    height: '100%',
                  }}
                >
                  Browse
                </div>
                <VisuallyHiddenInput
                  type='file'
                  onChange={uploadFile}
                  onClick={(event: any) => {
                    event.target.value = null;
                  }}
                />
              </Button>
            </Grid>
          </Fragment>

          {/* {!loading.success && (
            <Box
              sx={{
                display: 'flex',
                height: '500px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {loading.isLoading ? <CircularProgress /> : <AlertIcon color={palette.warning.main} />}
              <Typography variant='h2' m={2}>
                {loading.message}
              </Typography>
              {!loading.isLoading && (
                <FileExport exportData={excelSchema} isTemplate={true} exportFileName={'template'} />
              )}
            </Box>
          )} */}
          {loading.success === true && extractedData.length > 0 && (
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign={'right'}>
                <div style={{ height: '500px', width: '100%', marginTop: '10px' }}>
                  <DataGrid
                    rows={extractedData}
                    columns={columns}
                    disableColumnMenu
                    hideFooterPagination
                    hideFooter
                    disableRowSelectionOnClick
                    rowHeight={75}
                    sx={{
                      '&.MuiDataGrid-root': {
                        fontSize: '1rem',
                        backgroundColor: 'white',
                      },
                      '&.MuiDataGrid-root .MuiDataGrid-withBorderColor': {
                      },
                      '& .MuiDataGrid-cell': {
                        backgroundColor: 'white',
                      },
                      '& .MuiDataGrid-cell:hover': {
                        backgroundColor: 'white',
                      },
                      '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
                        outline: 'none !important',
                      },
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12} textAlign={'center'}>
            <Button variant='outlined' sx={{ m: 2 }} onClick={closeModal}>
              Cancel
            </Button>
            <Button
              disabled={loading.message != '' || extractedData.filter((item) => item.hasError).length > 0}
              variant='contained'
              onClick={handleSave}
            >
              Save
            </Button>
          </Grid>
        </> : <>
          <Button
            variant='outlined'
            startIcon={<ExcelIcon {...(!props.hasAccess && { style: {} })} />}
            component='label'
            sx={{ ...style, height: '42px' }}
            disabled={!props.hasAccess}
          >
            Import Excel / CSV
            <VisuallyHiddenInput
              type='file'
              onChange={uploadFile}
              onClick={(event: any) => {
                event.target.value = null;
              }}
            />
          </Button>
          <Modal
            sx={{ height: '200px' }}
            customStyles={{ width: 'fit-content !important', maxWidth: '1500px !important', minWidth: '800px' }}
            title={loading.success ? 'Verify Uploaded Data' : loading.isLoading ? 'Loading' : 'Upload Error'}
            open={isModalOpen}
            handleClose={closeModal}
          >
            {!loading.success && (
              <Box
                sx={{
                  display: 'flex',
                  height: '500px',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {loading.isLoading ? <CircularProgress /> : <AlertIcon color={palette.warning.main} />}
                <Typography variant='h2' m={2}>
                  {loading.message}
                </Typography>
                {!loading.isLoading && (
                  <FileExport exportData={excelSchema} isTemplate={true} exportFileName={'template'} />
                )}
              </Box>
            )}
            {loading.success === true && extractedData.length > 0 && (
              <Grid container spacing={2}>
                <Grid item xs={12} textAlign={'right'}>
                  <div style={{ height: '500px', width: '100%', marginTop: '10px' }}>
                    <DataGrid
                      rows={extractedData}
                      columns={columns}
                      disableColumnMenu
                      hideFooterPagination
                      hideFooter
                      disableRowSelectionOnClick
                      rowHeight={75}
                      sx={{
                        '&.MuiDataGrid-root': {
                          fontSize: '1rem',
                          backgroundColor: 'white',
                        },
                        '&.MuiDataGrid-root .MuiDataGrid-withBorderColor': {
                        },
                        '& .MuiDataGrid-cell': {
                          backgroundColor: 'white',
                        },
                        '& .MuiDataGrid-cell:hover': {
                          backgroundColor: 'white',
                        },
                        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
                          outline: 'none !important',
                        },
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} textAlign={'center'}>
                  <Button variant='outlined' sx={{ m: 2 }} onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button
                    disabled={loading.message != '' || extractedData.filter((item) => item.hasError).length > 0}
                    variant='contained'
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            )}
          </Modal>
        </>}
    </>
  );
};

export default FileImport;
